import * as React from "react";
// NOTE: Should be using actual props from kanopi Block
import { BlockProps } from "baseui/block";
import { Block } from "../Block";

const DL: React.FC<BlockProps> = (props) => (
  <Block as="dl" marginTop="scale600" marginBottom="scale600" {...props} />
);
const DT: React.FC<BlockProps> = (props) => (
  <Block as="dt" font="ParagraphMedium" {...props} />
);
const DD: React.FC<BlockProps> = (props) => (
  <Block as="dd" margin={0} color="mono700" font="ParagraphXSmall" {...props} />
);

export { DL, DT, DD };
